import { baseUrl } from '@percent/partner-dashboard/services/apiPaths'
import { PBPListResponse, PBPResponse } from '@percent/partner-dashboard/services/types/pbpResponses.types'
import { TemplatesServiceCapabilities } from './templates.types'
import {
  CreateWaiverTemplatePayload,
  GetWaiverTemplatesListProps,
  UpdateWaiverTemplatePayload,
  WaiverTemplate
} from './waiverTemplateService.types'

export const waiverTemplateService = ({ percentClient }: TemplatesServiceCapabilities) => ({
  getWaiverTemplatesList: (params: GetWaiverTemplatesListProps) => {
    const { query, status, direction, sort, ...otherParams } = params

    return percentClient.get<PBPListResponse<WaiverTemplate>>(`${baseUrl}volunteering/waiver-templates`, {
      params: {
        ...otherParams,
        ...(query && { query }),
        ...(status?.length && { status }),
        ...(sort && { sort }),
        ...(direction && { direction })
      }
    })
  },
  getWaiverTemplate: (templateId: string) => {
    return percentClient.get<PBPResponse<WaiverTemplate>>(`${baseUrl}volunteering/waiver-templates/${templateId}`)
  },
  createWaiverTemplate: (payload: CreateWaiverTemplatePayload) => {
    return percentClient.post<PBPResponse<WaiverTemplate>>(`${baseUrl}volunteering/waiver-templates`, payload)
  },
  updateWaiverTemplate: ({ templateId, ...payload }: UpdateWaiverTemplatePayload) => {
    return percentClient.patch<PBPResponse<WaiverTemplate>>(
      `${baseUrl}volunteering/waiver-templates/${templateId}`,
      payload
    )
  },
  archiveWaiverTemplate: (templateId: string) => {
    return percentClient.delete(`${baseUrl}volunteering/waiver-templates/${templateId}`)
  },
  setDefaultWaiverTemplate: (templateId: string) => {
    return percentClient.post(`${baseUrl}volunteering/waiver-templates/${templateId}/default`)
  },
  removeDefaultWaiverTemplate: (templateId: string) => {
    return percentClient.delete(`${baseUrl}volunteering/waiver-templates/${templateId}/default`)
  }
})
